import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment-timezone';
import { ActivatedRoute, Router } from '@angular/router';
import { LookupModalComponent } from '../../data-type-widgets/data-type/shared/lookup/lookup-modal/lookup-modal.component';
import { DrawLottolandComplianceService } from './draw-lottoland-compliance.service';
import { DrawComplianceDTO } from './draw-compliance.dto';
import { EnvironmentService } from '../../../common/services/env-configuration/environment.service';
import { FieldConfigDTO } from '../../../system/system-dtos';
import { DataType } from '../../data-type-widgets/data-type/data-type-component';

@Component({
  selector: 'app-draw-lottoland-compliance',
  templateUrl: './draw-lottoland-compliance.component.html',
  styleUrls: ['./draw-lottoland-compliance.component.scss'],
  standalone: false,
})
export class DrawLottolandComplianceComponent implements OnInit {
  public draws: DrawComplianceDTO[];

  public dataSource: MatTableDataSource<any>;

  public selected;

  public loading: boolean = true;

  public fields: FieldConfigDTO[] = [
    {
      name: 'drawDateTime',
      label: 'Draw date time',
      type: DataType.date_time,
      timezone: 'GMT',
    },
    {
      name: 'lottolandId',
      label: 'Lottoland id',
      type: DataType.text,
    },
    {
      name: 'lottomartId',
      label: 'Lottomart id',
      type: DataType.text,
    },
  ];

  public fieldNames = this.fields.map((f) => f.name);

  public successDrawId: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LookupModalComponent>,
    private service: DrawLottolandComplianceService,
    private router: Router,
    private envService: EnvironmentService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.service.getCompliance(this.data.lottoId).subscribe((d) => {
      this.draws = d.sort((a, b) => (moment(a.drawDateTime).isAfter(moment(b.drawDateTime)) ? 1 : -1));
      this.dataSource = new MatTableDataSource<any>(this.draws);
      this.loading = false;
    });
  }

  getClassesForRow(row) {
    const classes = [];
    if (row.lottomartId) {
      classes.push('not-selectable');
    }

    if (row.lottomartId) {
      classes.push('selectable');
    }

    if (row.selected) {
      classes.push('selected');
    }
    return classes;
  }

  onRowClick(row, event: any) {
    if (row.lottomartId) {
      return;
    }
    this.selected = row;
    this.dataSource.data.forEach((r) => (r.selected = false));
    row.selected = true;
  }

  createDraw() {
    this.loading = true;
    this.service.createDraw(this.selected.lottolandId, this.data.lottoId).subscribe((d) => {
      this.successDrawId = d.id;
      this.loading = false;
    });
  }

  goToNewDraw() {
    this.router.navigate([`./draws/${this.successDrawId}/overall`], { relativeTo: this.route.parent });
    this.dialogRef.close();
  }
}
